const DrawingMode = {
    'STOP':null,
    'POLYGON':'polygon'
}

export default DrawingMode
